/**
 * Global Logger Configuration
 * 
 * This file must be imported BEFORE any other imports in the application entry point (index.js).
 * It handles the suppression of console.log in production environments.
 * 
 * By placing this in a separate file and importing it first, we ensure that
 * Top-Level Logs (logs that run as soon as a module is imported) in other files
 * are also suppressed, because this code runs before those modules are even evaluated.
 */

if (process.env.NODE_ENV === 'production') {
    // Save the original console.log just in case we ever need to restore it (optional/advanced)
    // const originalLog = console.log;

    // Override console.log with a no-op function
    console.log = () => { };

    // Note: console.error and console.warn are intentionally left alone
    // so that critical errors are still visible in production logs.
}
